import React, { FunctionComponent } from 'react';

import { TrackingBoundary } from './TrackingBoundary';

interface Props {
  startTime: string;
  endTime: string;
}

export const TrackingBoundariesWrapper: FunctionComponent<Props> = ({
  startTime,
  endTime,
  children,
}) => (
  <>
    <TrackingBoundary displayTime={startTime} boundary="start" />
    {children}
    <TrackingBoundary displayTime={endTime} boundary="end" />
  </>
);
